import { Navigate, useLocation } from 'react-router-dom';
import React, { useEffect } from 'react';
import { useAuthStore } from '../../../store/authStore';
import { useSendSalesforceCode } from '../../../apiHooks/mutations/integrationMutations/salesforceMutation';

const SalesforceRoute = () => {
  const { isLoggedIn } = useAuthStore();

  const location = useLocation();
  const queryParams = new URLSearchParams(location.search);
  const codeParam = queryParams.get('code');
  const { mutateAsync: sendSalesforceCode } = useSendSalesforceCode();

  useEffect(() => {
    if (codeParam && isLoggedIn) {
      sendSalesforceCode(codeParam).then(() => {});
    }

    if (codeParam && !isLoggedIn) {
      localStorage.setItem('salesforceCode', codeParam);
    }

    if (localStorage.getItem('salesforceCode') && isLoggedIn) {
      sendSalesforceCode(localStorage.getItem('salesforceCode') as string).then(() => {});
    }
  }, [isLoggedIn]);

  if (isLoggedIn) {
    return <Navigate to="/dashboard" />;
  }

  return <Navigate to="/auth" />;
};

export default SalesforceRoute;
